import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumb = ({ items, currentPage }) => {
  const location = useLocation();
  
  // Default breadcrumb based on current path if no items provided
  const defaultItems = [
    { label: 'Home', path: '/' }
  ];
  
  const breadcrumbItems = items || defaultItems;
  
  return (
    <nav className="flex items-center space-x-1 text-sm mb-4 px-1 py-2 bg-white/50 rounded-lg backdrop-blur-sm">
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <ChevronRight className="w-4 h-4 text-gray-400 flex-shrink-0" />
          )}
          {index === 0 && (
            <Home className="w-4 h-4 text-[#2A9FCB] mr-1" />
          )}
          {item.path && index < breadcrumbItems.length - 1 ? (
            <Link 
              to={item.path}
              className="text-[#2A9FCB] hover:text-[#2A9FCB]/80 hover:underline transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className={index === breadcrumbItems.length - 1 ? 'text-gray-600 font-medium' : 'text-[#2A9FCB]'}>
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
      {currentPage && (
        <>
          <ChevronRight className="w-4 h-4 text-gray-400 flex-shrink-0" />
          <span className="text-gray-600 font-medium">{currentPage}</span>
        </>
      )}
    </nav>
  );
};

export default Breadcrumb;
